import styled from 'styled-components'

export const TextDisclaimer = styled.p`
  font-family: Ubuntu, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #9f9f9f;
  margin: 8px auto;
  max-width: 600px;
`
